import { render, staticRenderFns } from "./AccountsOverview.vue?vue&type=template&id=45e49482&scoped=true&"
import script from "./AccountsOverview.vue?vue&type=script&lang=js&"
export * from "./AccountsOverview.vue?vue&type=script&lang=js&"
import style0 from "./AccountsOverview.vue?vue&type=style&index=0&id=45e49482&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e49482",
  null
  
)

export default component.exports